import { render, staticRenderFns } from "./TemplateFour.vue?vue&type=template&id=9cfce490&"
import script from "./TemplateFour.vue?vue&type=script&lang=js&"
export * from "./TemplateFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports